import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

import {
  sessionDataHandler,
  addNotification,
  changeEngagementPhase,
  initSession,
  AppState,
  EngagementPhase,
  Header,
  notifications,
  NotificationBar,
} from "..";
import {useAuth} from "@bounce/shared/contexts";
import {useAmplitude} from "~/contexts";
import {Pages} from "~/bi-events/enum";

export const StartChatWithMessagePhase = () => {
  const {pageClickEvent} = useAmplitude();
  const {name, email, query} = useSelector((state: AppState) => state.session.preEngagementData) || {};
  const {token, userId} = useAuth();
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    pageClickEvent({page: Pages.CHAT, cta: "start_chat", data: {chat_text: query}});
    dispatch(changeEngagementPhase({phase: EngagementPhase.Loading}));
    try {
      const data = await sessionDataHandler.fetchAndStoreNewSession({
        formData: {
          friendly_name: name,
          email,
          query,
        },
        userId,
        userToken: token,
      });
      // @ts-ignore
      dispatch(initSession({token: data.token, conversationSid: data.conversation_sid}));
    } catch (err) {
      console.error("StartChatWithMessagePhase", err);
      dispatch(addNotification(notifications.failedToInitSessionNotification((err as Error).message)));
    }
  };

  useEffect(() => {
    handleSubmit();
  }, []);

  return (
    <>
      <Header />
      <NotificationBar />
    </>
  );
};
